import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '..'

interface ChatbotState {
  email: string,
  conversationId: string
}

const initialState = { 
    email: "HEATHADKISSON@GMAIL.COM",
    conversationId: "123"
} as ChatbotState

const chatbotSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setEmail(state, action) {
        state.email = action.payload
    },
    setConversationId(state, action) {
        state.conversationId = action.payload
    }
   }
})

export const { setEmail, setConversationId } = chatbotSlice.actions
export default chatbotSlice.reducer
export const selectConversationId = (state: RootState) => state.chatbot.conversationId
export const selectEmail = (state: RootState) => state.chatbot.email